import { SVGProps } from 'react'

export const SearchNoBg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="none" viewBox="0 0 21 20" {...props}>
    <path
      fill="currentColor"
      d="M13.63 11.88h-.659l-.233-.226a5.393 5.393 0 001.308-3.525 5.417 5.417 0 10-5.416 5.417 5.393 5.393 0 003.525-1.309l.225.234v.658l4.166 4.158 1.242-1.241-4.158-4.167zm-5 0a3.745 3.745 0 01-3.75-3.75 3.745 3.745 0 013.75-3.75 3.745 3.745 0 013.75 3.75 3.745 3.745 0 01-3.75 3.75z"
    ></path>
  </svg>
)
